export enum InlineMessageType {
  ERROR = 'error',
  WARNING = 'warning',
  INFO_CIRCLE = 'info_circle',
  INFO_ARROW = 'info_arrow',
  INDICATOR_INFO_CIRCLE = 'indicator_info_circle'
}
